import {
  ANNOTATION_LOCATION,
  ANNOTATION_SOURCE_LOCATION,
  type Entity,
} from '@backstage/catalog-model';
import { GitHubUrlParser } from '@internal/backstage-plugin-github-common';

export type RepoRef = {
  owner: string;
  repo: string;
};

const GITHUB_PROJECT_SLUG_ANNOTATION = 'github.com/project-slug';

export function getEntityRepoRef(entity: Entity): RepoRef | undefined {
  const annotations = entity.metadata.annotations ?? {};
  const projectSlug = annotations[GITHUB_PROJECT_SLUG_ANNOTATION];
  const projectSlugRepoRef = parseProjectSlug(projectSlug);

  if (projectSlugRepoRef) {
    return projectSlugRepoRef;
  }

  return (
    parseCatalogLocationAnnotation(annotations[ANNOTATION_SOURCE_LOCATION]) ??
    parseCatalogLocationAnnotation(annotations[ANNOTATION_LOCATION])
  );
}

function parseProjectSlug(projectSlug: string | undefined): RepoRef | undefined {
  if (!projectSlug) {
    return undefined;
  }

  const [owner, repo, ...extraParts] = projectSlug.split('/');
  if (!owner || !repo || extraParts.length > 0) {
    return undefined;
  }

  return { owner, repo };
}

function parseCatalogLocationAnnotation(annotation: string | undefined): RepoRef | undefined {
  if (!annotation) {
    return undefined;
  }

  return GitHubUrlParser.parseCatalogLocationAnnotation(annotation);
}
